/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IssueCsrfToken200Response
 */
export interface IssueCsrfToken200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof IssueCsrfToken200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof IssueCsrfToken200Response
     */
    message: string;
    /**
     * CSRFトークン
     * @type {string}
     * @memberof IssueCsrfToken200Response
     */
    token?: string;
}

/**
 * Check if a given object implements the IssueCsrfToken200Response interface.
 */
export function instanceOfIssueCsrfToken200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function IssueCsrfToken200ResponseFromJSON(json: any): IssueCsrfToken200Response {
    return IssueCsrfToken200ResponseFromJSONTyped(json, false);
}

export function IssueCsrfToken200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IssueCsrfToken200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'token': !exists(json, 'token') ? undefined : json['token'],
    };
}

export function IssueCsrfToken200ResponseToJSON(value?: IssueCsrfToken200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'token': value.token,
    };
}

